module.exports = __webpack_public_path__ + "img/tuin_oostkant.44418794.png";